import React, { useEffect, useState } from 'react'
import moment from 'moment'

import {
    SnippetsOutlined,
    CodeSandboxOutlined,
    DownloadOutlined,
    SearchOutlined,
    ClearOutlined
} from '@ant-design/icons';

import {
    PageHeader,
    Table,
    Space,
    Button,
    DatePicker,
    Select,
    Input,
    Row,
    Col
} from 'antd';

import './DTE.scss';

import { useApi } from '../../Utils';
import { ColumnsType } from 'antd/lib/table';
import { useHistory } from 'react-router-dom';
import JSZip from 'jszip';
// @ts-ignore
import JSZipUtils from 'jszip-utils';

const { RangePicker } = DatePicker
const { Option } = Select

const dataTypes: string[] = []
// @ts-ignore
dataTypes['33'] = 'Factura'
// @ts-ignore
dataTypes['61'] = 'Nota de crédito'
// @ts-ignore
dataTypes['52'] = 'Guía de despacho'


const DownloadButton = ({ record }: any) => {
    const [loading, setLoading] = useState(false)

    return <Button loading={loading} onClick={() => {
        setLoading(true)
        const oReq = new XMLHttpRequest();
        oReq.open("GET", record.url, true);
        oReq.responseType = "blob";
        oReq.onload = function (oEvent) {
            const blob = oReq.response;
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `${dataTypes[record.typeDoc]} ${record.name}`.replace(' ', '_');
            a.click();
        }
        oReq.send();
        oReq.onreadystatechange = () => {
            if (oReq.readyState === 4) {
                setLoading(false)
            }
        }
    }} type="ghost" icon={<DownloadOutlined />} size='small'>
        Descargar
    </Button>
}

function DTE({ exposeSubMenu, setMainLoading }: any) {
    const history = useHistory()

    const { data, loading, fetch } = useApi<any>('get', 'v3/dtes/list', {
        requiredToken: true,
        onRequest: true
    })
    const [facturas, setFacturas] = useState<Array<any>>([])
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
    const [currentShow, setCurrentShow] = useState<any[]>([])

    const defaultRange: [moment.Moment, moment.Moment] = [moment().subtract(1, 'day'), moment()]
    const [dateRange, setDateRange] = useState<[moment.Moment, moment.Moment]>(defaultRange)
    const [typeDoc, setTypeDoc] = useState<string>('')
    const [folio, setFolio] = useState<string>('')

    const buildParams = (dr = dateRange, td = typeDoc, f = folio) => {
        const params: Record<string, string> = {
            from: dr[0].format('YYYY-MM-DD'),
            to: dr[1].format('YYYY-MM-DD')
        }
        if (td) params.typeDoc = td
        if (f.trim()) params.folio = f.trim()
        return params
    }

    useEffect(() => {
        fetch(buildParams())
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (data && !loading) {
            setFacturas(data.result.map((item: any) => ({ ...item, key: item.id })))
            setCurrentShow(data.result.map((item: any) => ({ ...item, key: item.id })))
        }
    }, [data, loading])

    useEffect(() => {
        setMainLoading(loading)
    }, [loading, setMainLoading])

    const handleSearch = () => {
        fetch(buildParams())
    }

    const handleReset = () => {
        setDateRange(defaultRange)
        setTypeDoc('')
        setFolio('')
        fetch(buildParams(defaultRange, '', ''))
    }

    const getFiles = () => {
        if (selectedRowKeys.length === 0) return
        setMainLoading(true)
        const urls = selectedRowKeys.map((item: any) =>
            facturas.find((item2: any) => item2.id === item).url
        )
        const ids = selectedRowKeys.map((item: any) =>
            facturas.find((item2: any) => item2.id === item).name.replace('.pdf', '')
        )
        let count = 0

        const zip = new JSZip()
        urls.forEach((url: any) => {
            JSZipUtils.getBinaryContent(url, (err: any, data: any) => {
                if (err) throw err
                zip.file(facturas.find(fact => fact.url === url).name, data, { binary: true })
                count++
                if (count === urls.length) {
                    zip.generateAsync({ type: 'blob' }).then((content: any) => {
                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(content);
                        a.download = `${ids.join('_')}.zip`;
                        a.click();
                        setTimeout(() => setMainLoading(false), 1000)
                    })
                }
            })
        })
    }


    const columns: ColumnsType<any> = [
    {
        title: 'Tipo',
        dataIndex: 'typeDoc',
        render: (value) => (
            <Space size="middle">
                <CodeSandboxOutlined />
                <span>{dataTypes[value]}</span>
            </Space>
        )
    },
    {
        title: 'Número',
        dataIndex: 'name',
        defaultSortOrder: 'descend',
        sorter: (a: any, b: any) => Number(a.name.replace('.pdf', '')) - Number(b.name.replace('.pdf', '')),
        render: (value: string) => (
            <Space size="middle">
                <span>{value.replace('.pdf', '')}</span>
            </Space>
        )
    },
    {
        title: 'Fecha de Emisión',
        dataIndex: 'created_at',
        render: (value: string) => (
            <Space size="middle">
                <span>{value}</span>
            </Space>
        )
    },
    {
        title: 'Acciones',
        dataIndex: 'action',
        render: (text: any, record: any) => (
            <Space size="middle">
                <DownloadButton record={record} />
            </Space>
        )
    },
    ];

    useEffect(() => {
        if (!!exposeSubMenu) {
            exposeSubMenu([
                { key: 'index', name: 'Listado de documentos', icon: <SnippetsOutlined /> }
            ])
        }
    }, [exposeSubMenu])

    function onChange(pagination: any, filters: any, sorter: any, extra: any) {
        setCurrentShow(extra.currentDataSource)
    }

    const subtitleRange = `${dateRange[0].format('DD/MM/YYYY')} — ${dateRange[1].format('DD/MM/YYYY')}`

    return (
        <div className="App">
            <div className="DTE">
                <PageHeader
                    ghost={true}
                    onBack={() => history.push('/')}
                    title="Listado de documentos"
                    subTitle={`${facturas.length} documento${facturas.length !== 1 ? 's' : ''} · ${subtitleRange}`}
                    extra={[
                        <Button key="2" onClick={() => fetch(buildParams())} type="default">Actualizar</Button>,
                        <Button disabled={!selectedRowKeys.length} key="1" onClick={getFiles} type='primary'>
                            Descargar seleccionados {selectedRowKeys.length > 0 ? `(${selectedRowKeys.length})` : ''}
                        </Button>,
                    ]}
                    />

                <div className="DTE__Filters">
                    <Row gutter={[8, 8]} align="middle">
                        <Col>
                            <RangePicker
                                value={dateRange}
                                format="DD/MM/YYYY"
                                onChange={(dates, _dateStrings) => {
                                    if (dates && dates[0] && dates[1]) {
                                        setDateRange([dates[0] as moment.Moment, dates[1] as moment.Moment])
                                    }
                                }}
                                allowClear={false}
                            />
                        </Col>
                        <Col>
                            <Select
                                value={typeDoc || undefined}
                                placeholder="Tipo de documento"
                                allowClear
                                style={{ width: 180 }}
                                onChange={(val: string) => setTypeDoc(val || '')}
                            >
                                <Option value="33">Factura</Option>
                                <Option value="52">Guía de despacho</Option>
                                <Option value="61">Nota de crédito</Option>
                            </Select>
                        </Col>
                        <Col>
                            <Input
                                value={folio}
                                placeholder="Folio / número"
                                style={{ width: 140 }}
                                onChange={(e) => setFolio(e.target.value)}
                                onPressEnter={handleSearch}
                            />
                        </Col>
                        <Col>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch} loading={loading}>
                                Buscar
                            </Button>
                        </Col>
                        <Col>
                            <Button icon={<ClearOutlined />} onClick={handleReset}>
                                Limpiar
                            </Button>
                        </Col>
                    </Row>
                </div>

                <div className="Wrapper">
                    <Table
                        columns={columns}
                        dataSource={facturas}
                        size='small'
                        sticky
                        loading={loading}
                        pagination={false}
                        footer={() => `Estás viendo ${currentShow.length} de ${facturas.length} documento${facturas.length !== 1 ? 's' : ''}.`}
                        rowSelection={{
                            onChange: (selectedRowKeys: React.Key[]) => {
                                setSelectedRowKeys(selectedRowKeys)
                            },
                            selectedRowKeys
                        }}
                        onChange={onChange} />
                </div>
            </div>
        </div>
    )
}

export default DTE
